module.exports = __webpack_public_path__ + "static/Portal_Half-8f9ee08bddee2b8ee8e41563ae558a8a.gif";